import { HubFeature, LocalizationResponse, LocType, LocUiType, PortalType } from '@ats/api/cm';
import { gql } from 'apollo-angular';
import { Localization, LocDisplayType } from '../models';

export * from './localization-gql.service';

export const LOCALIZATION_QUERY = gql`
	query localizationList($request: GetLocalizationListRequest!) {
		clientSponsor {
			localizationList(request: $request) {
				cultureName
				name
				value
				defaultValue
				type
				path
				description
				shared
				htmlAllowed
				uiType
				isCustomized
				feature {
					id
					key
				}
			}
		}
	}
`;

export const mapLocUiType = (uiType: LocUiType | null = null): LocDisplayType => {
	switch (uiType) {
		case LocUiType.ColumnHeading:
		case LocUiType.FieldLabel:
			return 'Label';
		case LocUiType.FieldError:
			return 'Error';
		case LocUiType.FieldHint:
		case LocUiType.MenuItem:
			return 'Content';
		case LocUiType.SystemValue:
			return 'System';
		case LocUiType.ImageInformation:
			return 'Title';
		case LocUiType.NotificationMessage:
			return 'Content';
		default:
			return uiType || 'Content';
	}
};

export const mapLegacyLocs = (
	locs: LocalizationResponse[],
	defaultType: LocType
): Record<string, Localization> =>
	locs.reduce(
		(locs, loc) => {
			return {
				...locs,
				[loc.name]: mapLegacyLoc(loc, defaultType),
			};
		},
		{} as Record<string, Localization>
	);

export const mapLegacyLoc = (loc: LocalizationResponse, defaultType: LocType): Localization => ({
	name: loc.name,
	defaultValue: loc.defaultValue || '',
	description: loc.description || '',
	type: loc.type || defaultType,
	htmlAllowed: loc.htmlAllowed || false,
	shared: loc.shared || false,
	displayPath: loc.path || '',
	feature: loc.feature?.key || legacyDefaultFeature(loc),
	cultureInfoName: loc.cultureName,
	displayType: mapLocUiType(loc.uiType),
	englishValueResolved: loc.defaultValue || '', // There will be a reckoning for this
	value: loc.value || loc.defaultValue || '',
	hasClientValue: loc.isCustomized || false,
	isLegacy: true,
	portal: (loc.type || defaultType).toString().includes('CandidatePortal') ? 'CP' : 'SP',
});

const legacyDefaultFeature = (loc: LocalizationResponse): HubFeature => {
	return loc.portalType === PortalType.CandidatePortal
		? HubFeature['CandidateAccess']
		: HubFeature['Core'];
};
